import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      // Backend always returns { ok: true } regardless of whether the email
      // exists, to avoid leaking the user list. We mirror that on the frontend
      // by always showing the same confirmation message.
      await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSubmitted(true);
    } finally {
      setBusy(false);
    }
  }

  if (submitted) {
    return (
      <div className="max-w-sm mx-auto px-4 py-16 text-center">
        <div className="w-12 h-12 mx-auto rounded-full bg-emerald-100 flex items-center justify-center mb-4">
          <Mail className="text-emerald-600" size={24} />
        </div>
        <h1 className="text-xl font-bold mb-2">Check your inbox</h1>
        <p className="text-slate-600 text-sm">
          If an account exists for <strong>{email}</strong>, we've sent a password-reset link. The link expires in one hour.
        </p>
        <p className="text-slate-500 text-xs mt-4">
          Didn't get it? Check your spam folder, or{' '}
          <button onClick={() => setSubmitted(false)} className="text-brand underline">
            try again
          </button>.
        </p>
        <Link to="/login" className="inline-block mt-6 text-sm text-brand underline">Back to log in</Link>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="max-w-sm mx-auto px-4 py-12 space-y-4">
      <h1 className="text-2xl font-bold">Reset your password</h1>
      <p className="text-sm text-slate-600">
        Enter the email associated with your account and we'll send you a reset link.
      </p>
      <input
        type="email"
        required
        placeholder="Email"
        className="w-full border rounded px-3 py-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        disabled={busy}
        className="w-full bg-brand text-white rounded py-2 font-medium disabled:opacity-50"
      >
        {busy ? 'Sending…' : 'Send reset link'}
      </button>
      <div className="text-center text-sm">
        <Link to="/login" className="text-slate-500 hover:text-brand">Back to log in</Link>
      </div>
    </form>
  );
}
